import { Autocomplete, TextField } from "@mui/material";
import { styled } from "@mui/system";
import React from "react";

const AutoCompleteListFormik = ({
  items,
  name,
  label,
  formik,
  formikName,
  required = false,
}) => {
  const GroupHeader = styled("div")(({ theme }) => ({
    position: "sticky",
    top: "-8px",
    padding: "4px 10px",
    color: theme.palette.primary.main,
  }));

  const GroupItems = styled("ul")({
    padding: 0,
  });

  const uniqueItems = [
    ...new Map(items.map((item) => [item[name], item])).values(),
  ];

  const options = uniqueItems.map((option) => {
    const firstLetter = option[name][0].toUpperCase();
    return {
      firstLetter: /[0 - 9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };
  });

  // console.log("Options", options);

  return (
    <Autocomplete
      fullWidth
      options={options.sort(
        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
      )}
      ListboxProps={{
        className: "myCustomList",
      }}
      groupBy={(option) => option.firstLetter}
      getOptionLabel={(option) => option[name]}
      sx={{
        "& .MuiOutlinedInput-root": {
          padding: 0.5,
        },
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} required={required} />
      )}
      renderGroup={(params) => (
        <li key={params.key}>
          {/* {console.log("param", params)} */}
          <GroupHeader>{params.group}</GroupHeader>
          <GroupItems>{params.children}</GroupItems>
        </li>
      )}
      value={formik.values[formikName]}
      onChange={(e, value) => {
        console.log("Auto comp",value);
        formik.setFieldValue(formikName, value);
      }}
      // onChange={formik.handleChange(formikName)}
      error={formik.errors[formikName]}
      isOptionEqualToValue={(option, value) => {
        // console.log({ optionID: option.id, valueID: value.id });
        return option?.id === value?.id;
      }}
    />
  );
};

export default AutoCompleteListFormik;
